import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import NoDataFound from "../../../assets/images/empty_item.svg";
import "./LineChartHighChart.css";

interface PropData {
  data: any;
  type: any;
  onTypeChange: any;
}

const LineChartHighChart = (props: PropData) => {
  return (
    <>
      <div className="overview-card">
        <div className="card-body">
          <div className="d-flex align-items-center mb-3">
            <h5 className="mb-0">Charts</h5>
            <div className="ms-auto">
              <select
                className="form-select form-select-sm w-auto"
                onChange={(e) => {
                  props.onTypeChange(e.target.value);
                }}
                defaultValue={props.type}
              >
                <option>Daily</option>
                <option>Weekly</option>
                <option>Monthly</option>
              </select>
            </div>
          </div>
          {props?.data ? (
            <>
              <HighchartsReact highcharts={Highcharts} options={props.data} />
            </>
          ) : (
            <>
              <div className="table-wrap position-relative">
                <div className="no-data-flound">
                  <div className="text-center">
                    <img
                      alt=""
                      src={NoDataFound}
                      width={110}
                      className="mb-3"
                    />
                    <h3 className="text-secondary font-12">
                      No Data Found
                    </h3>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};
export default LineChartHighChart;
